import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Menu from './Menu';

import { useUrlGenerator } from '@folklore/routes';
import { useCurrentPage } from '../../contexts/PagesContext';
import { useLocales } from '../../contexts/SiteContext';

import styles from '../../../styles/menus/locales-menu.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const LocalesMenu = ({ className }) => {
    const route = useUrlGenerator();
    const { locale } = useIntl();
    const locales = useLocales();
    const page = useCurrentPage();
    const { metadata: { urls = {} } = {} } = page || {};

    const items = useMemo(
        () =>
            locales.map((loc) => ({
                id: loc,
                label: loc,
                url: urls[loc] || `${route('home')}/${loc}`,
                external: true,
                target: '_self',
                rel: null,
                active: loc === locale,
            })),
        [route, locales, locale, urls],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Menu
                items={items}
                className={styles.menu}
                itemsClassName={styles.items}
                itemClassName={styles.item}
                activeItemClassName={styles.active}
                linkClassName={styles.link}
            />
        </div>
    );
};

LocalesMenu.propTypes = propTypes;
LocalesMenu.defaultProps = defaultProps;

export default LocalesMenu;
